exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-form-card{margin-bottom:1.5rem;box-shadow:0 4px 6px rgba(0,0,0,.1)}.customer-form-card .card-header{background-color:#f8f9fa}.customer-list-card{margin-bottom:1.5rem;box-shadow:0 4px 6px rgba(0,0,0,.1)}.customer-list-card .card-header{background-color:#f8f9fa}.customer-view-card{margin-bottom:1.5rem;box-shadow:0 4px 6px rgba(0,0,0,.1)}.customer-view-card .card-header{background-color:#f8f9fa}.customer-view-card .table td{padding:.5rem}", ""]);

// exports
